export const QRListItem = ['Відкрийте QR-сканер у застосунку', 'Відскануйте QR-код.', 'Очікуйте'];
